import type { Lifecycle, Stage } from '@/domain/creature/types';
import { STAGE_DURATIONS } from '@/domain/care/constants';

export { STAGE_DURATIONS };

type StageDurations = typeof STAGE_DURATIONS;

export function computeStage(ageMs: number, durations: StageDurations = STAGE_DURATIONS): Stage {
  if (ageMs < durations.egg) return 'egg';
  if (ageMs < durations.egg + durations.baby) return 'baby';
  if (ageMs < durations.egg + durations.baby + durations.teen) return 'teen';
  if (
    ageMs <
    durations.egg + durations.baby + durations.teen + durations.adult
  ) {
    return 'adult';
  }
  return 'elder';
}

export function shouldDieOfOldAge(lifecycle: Lifecycle, nowMs: number, durations: StageDurations = STAGE_DURATIONS): boolean {
  if (lifecycle.elderSince === null) return false;
  return nowMs - lifecycle.elderSince >= durations.elder;
}
